/* global axios */
const url = accountId => `/api/v1/accounts/${accountId}/bug_reports`;
const formData = (attributes, files) => {
  const data = new FormData();
  Object.entries(attributes).forEach(([key, value]) => data.append(key, value));
  files.forEach(file => data.append('images[]', file));
  return data;
};
export default {
  list: (accountId, page) => axios.get(url(accountId), { params: { page } }),
  show: (accountId, id) => axios.get(`${url(accountId)}/${id}`),
  create: (accountId, attributes, files, options) =>
    axios.post(url(accountId), formData(attributes, files), options),
  comment: (accountId, id, body, files, submissionId, options) =>
    axios.post(
      `${url(accountId)}/${id}/comment`,
      formData({ body, submission_id: submissionId }, files),
      options
    ),
  download: (accountId, id, imageId) =>
    axios.get(`${url(accountId)}/${id}/images/${imageId}`, {
      responseType: 'blob',
    }),
};
